export default () => ({
    collapseInitialized: false,
    collapseExpanded: false,
    collapseCropped: true,
    cropEl: null,
    scrollHeight: 0,
    minHeight: 560,
    wrapHeight: 0,
    resizeTimeout: null,
    init() {

        // noinspection JSUnresolvedReference
        this.cropEl = this.$root.querySelector('.js-collapse-content');

        this.updateMinHeight();
    },
    updateCrop(){
        // Проверка видимости спойлера
        if(this.cropEl.offsetWidth === 0){
            return;
        }

        // Throttling the update logic
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            const newScrollHeight = this.cropEl.scrollHeight;

            // Only update if the scrollHeight has changed
            if (this.scrollHeight !== newScrollHeight) {
                this.scrollHeight = newScrollHeight;
                this.collapseCropped = this.scrollHeight - 60 > this.cropEl.clientHeight;
            }

            setTimeout(() => {
                if(!this.collapseInitialized){
                    this.collapseInitialized = true;
                }
            }, 50);

        }, 100);
    },
    updateMinHeight(){

        // noinspection JSUnresolvedReference
        this.minHeight = parseInt(this.$root.dataset.minHeight ?? 560);

        // Ждем чтобы высота корневого элемента обновилась
        Alpine.nextTick().then(() => {

            // noinspection JSUnresolvedReference
            this.wrapHeight = this.$root.clientHeight;

            if(this.wrapHeight - 60 > this.minHeight){
                this.minHeight = this.wrapHeight - 60;
            }
        });

        this.updateCrop();
    }
});
